import React from 'react';
import styled from '@emotion/styled';

const HiddenLoader = () => (
  <div className="hidden-loader" />
);

export default styled(HiddenLoader)`
  height: 0;
`;
